module.exports = __webpack_public_path__ + "static/media/slide-3.ac238e46.jpg";